import { TipoDocumentoDTO } from "./tipoDocumento.dto";
import {TpDocumento} from "../tpDocumento";

export class DocumentoDTO {

    id: number;
    tipoDocumento: TipoDocumentoDTO;
    key: string;
    nomeArquivo: string;
    nome: string;
    extensao: string;
    dataInclusao: string;
    arquivo: File;
    dataInformada: Date;
    observacao: string;
    docByte: Blob;
    descricao: string;
    uuid: string;
}